import usersMutations from "./mutations.js";
import usersActions from "./actions.js";
import usersGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            loggedInUser: null,
            loggedInUserInfo: {},
            loggedInUserId: null,
            isMetadataDockVisible: false,
            isAssetsDetailsPanelVisible: false,
            isMiniplayerVisible:false,
            selectedPlayerPanel:null,
            ip:null,
            usersBasicInfo:[]
        };
    },
    mutations: usersMutations,
    actions: usersActions,
    getters: usersGetters,
};